/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $SendProfessionalDocumentsResponse = {
  type: 'all-of',
  contains: [{
    type: 'ListResponse',
  }, {
    properties: {
      data: {
        type: 'array',
        contains: {
          type: 'ProfessionalDocument',
        },
        isRequired: true,
      },
    },
  }],
} as const;
